<template>
  <div class="rightTableDiv">
    <search-form
      ref="searchForm"
      @setSearchCondition="setSearchCondition"
      @clearSearch="clearSearch"
      @openDrawer="openDrawer"
      @derive="derive"
      @handleImport="handleImport"
      @changeScrollY="changeScrollY"
      @saveAdvanced="saveAdvanced"
      :selectedRows="selectedRows"
      :gas-search="true"
      :comid="treeSearchModel.subcompanyid"
      @showEquipmentHeadManage="showEquipmentHeadManage"
      @retrievesTheTableHeader="retrievesTheTableHeader"
      class="searchFormDiv"></search-form>
    <a-table
      :components="components"
      bordered
      class="assetTable"
      id="assetTable"
      :pagination="pagination"
      :rowKey="record => record.id"
      :columns="columns"
      :dataSource="tableData.data"
      :loading="tableData.loading"
      @change="handleTableChange"
      :rowSelection="{columnWidth: 40, selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
      :expanded-row-keys.sync="expandedRowKeys"
      :scroll="{ y: scrollY, x: scrollX }"
      :expandIconColumnIndex="2"
      :expandIcon="expandIcon"
      :customRow="changeRow"
      :indentSize="20"
      :rowClassName="rowClassName"
    >
      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px"
      >
        <!--          v-model="headerSearchModel[column.dataIndex]"-->
        <a-date-picker
          v-if="column.isDate"
          :showToday="false"
          format="YYYY-MM-DD"
          :placeholder="`选择搜索${column.title}`"
          v-model="selectedKeys[0]"
          @change="e => setSelectedKeys(e ? [e] : [])"
          style="width: 188px; margin-bottom: 8px; display: block;"
        />
        <a-input
          v-else
          v-ant-ref="c => (searchInput = c)"
          v-model="headerSearchModel['head_' + column.dataIndex]"
          :placeholder="`输入搜索${column.title}`"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          style="width: 188px; margin-bottom: 8px; display: block;"
        />
        <a-button
          type="primary"
          icon="search"
          size="small"
          style="width: 90px; margin-right: 8px"
          @click="handleSearch(selectedKeys,confirm, column)"
        >
          查询
        </a-button>
        <a-button size="small" style="width: 90px" @click="handleReset(clearFilters, column)">
          重置
        </a-button>
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered, column"
        type="search"
        :style="{ color: headerSearchModel['head_' + column.dataIndex] ? '#108ee9' : undefined }"
      />
      <!--      使用部门-->
      <template slot="relevantdeptname" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.relevantdeptname }}</template>
          <span class="assetNameTable">{{ record.relevantdeptname }}</span>
        </a-tooltip>
      </template>
      <!--      使用部门-->
      <template slot="usedeptname" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.usedeptname }}</template>
          <span class="assetNameTable">{{ record.usedeptname }}</span>
        </a-tooltip>
      </template>
      <!--      部门使用人-->
      <template slot="principalName" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.principalName }}</template>
          <span class="assetNameTable">{{ record.principalName }}</span>
        </a-tooltip>
      </template>
      <!--      规格型号-->
      <template slot="specification" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.specification }}</template>
          <span class="assetNameTable">{{ record.specification }}</span>
        </a-tooltip>
      </template>
      <!--      设备类型-->
      <template slot="equipmentTypeName" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.equipmentTypeName }}</template>
          <span class="assetNameTable">{{ record.equipmentTypeName }}</span>
        </a-tooltip>
      </template>
      <!--      设备状态-->
      <template slot="equipmentStatusName" slot-scope="text, record">
        <span class="blueIcon padding-4-8">{{ record.equipmentStatusName }}</span>
      </template>
      <!--      特性-->
      <template slot="peculiarity" slot-scope="text, record">
        <a-tooltip placement="top" v-if="record.isYlrqPeculiarity">
          <template slot="title">压力容器</template>
          <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #08409F80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #08409FFF">压</span>
        </a-tooltip>
        <a-tooltip placement="top" v-if="record.isTzsbPeculiarity">
          <template slot="title">特种设备</template>
          <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">特</span>
        </a-tooltip>
        <a-tooltip placement="top" v-if="record.isHbPeculiarity">
          <template slot="title">环保特性</template>
          <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #36BF7D80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #36BF7DFF">环</span>
        </a-tooltip>
      </template>
      <!--      供应商-->
      <template slot="manufacturer" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.manufacturer }}</template>
          <span class="assetNameTable">{{ record.manufacturer }}</span>
        </a-tooltip>
      </template>
      <!--      所属公司-->
      <template slot="suburl" slot-scope="text, record">
        <a-tooltip>
          <template slot="title">{{ record.suburl }}</template>
          <span class="assetNameTable">{{ record.suburl }}</span>
        </a-tooltip>
      </template>
      <template slot="actions2" slot-scope="text, record">
        <span>×</span>
      </template>
      <template slot="actions3" slot-scope="text, record">
        <span>×</span>
      </template>
      <template slot="actions6" slot-scope="text, record">
        <span class="orgIcon">故</span>
      </template>
      <template slot="actions7" slot-scope="text, record" style="background-color: red;">
        <span class="redIcon">即</span>
      </template>
      <template slot="footer">
        <div class="footerDiv">
          <!--            <div class="footerDivOne">-->
          <!--              <span>合集数量：</span>-->
          <!--              <span>{{ tableData.statistics.normalSum ? tableData.statistics.normalSum : 0 }}</span>-->
          <!--            </div>-->
          <div class="footerDivOne">
            <span class="totalNumDiv">
              <span>设备总数：</span>
              <span>{{ tableData.statistics.sumTotal ? tableData.statistics.sumTotal : 0 }}</span>
            </span>
          </div>
          <div class="footerDivTwo">
            <span class="totalNumDiv">
              <span>虚拟设备总数：</span>
              <span>{{ tableData.statistics.virtualTotal ? tableData.statistics.virtualTotal : 0 }}</span>
            </span>
          </div>
          <div class="footerDivThree">
            <span class="totalNumDiv">
              <span>常规设备总数：</span>
              <span>{{ tableData.statistics.routineTotal ? tableData.statistics.routineTotal : 0 }}</span>
            </span>
          </div>
        </div>
      </template>
    </a-table>
    <div class="filtrate" id="filtrate" v-drag v-show="searchNum === 0" @dblclick="showSearchModel">
      <span>详细筛选</span>
    </div>
    <div class="filtrateNum" id="filtrateNum" v-drag @dblclick="showSearchModel" v-show="searchNum > 0">
      <span>详细筛选</span>
      <div class="circle">
        <span>{{ searchNum }}</span>
      </div>
    </div>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li v-if="$auth('gasEquipmentLedger.add')" @click="openDrawer('add')">新增设备</li>
      <li v-if="$auth('gasEquipmentLedger.add') && visibleShow === 'all'" @click="plugInDevice('father')">插入父设备</li>
      <li v-if="$auth('gasEquipmentLedger.add') && visibleShow === 'all'" @click="plugInDevice('children')">插入子设备</li>
      <li v-if="$auth('gasEquipmentLedger.edit') && visibleShow === 'all'" @click="openDrawer('edit')">编辑</li>
      <li v-if="$auth('gasEquipmentLedger.add') && visibleShow === 'all'" @click="openDrawer('copy')">复制</li>
      <li v-if="$auth('gasEquipmentLedger.import')" @click="handleImport()">导入设备</li>
      <li v-if="$auth('gasEquipmentLedger.export') && visibleShow === 'all'" @click="derive()">导出当前台账</li>
      <li v-if="$auth('gasEquipmentLedger.del') && visibleShow === 'all'" @click="showDelTip()" style="color: red;">删除</li>
    </ul>
    <drawer-detail ref="drawerDetail" @getTableData="getTableData" @getDataTabs="getDataTabs" :disabled="disabled"></drawer-detail>
    <drawer-detail2
      ref="drawerDetail2"
      @getTableData="getTableData"
      @getDataTabs="getDataTabs"
      @setChildrenData="setChildrenData"
      @updateData="updateData"
      searchDept="45"
      searchDeviceType="1800000000"></drawer-detail2>
    <drawer-export ref="drawerExport" searchDeviceType="1800000000"></drawer-export>
    <import-modal ref="importModal" @getTableData="getTableData" searchDept="45" searchDeviceType="1800000000"></import-modal>
    <search-model ref="searchModel" @setSearchCondition="setSearchCondition" @retrievesTheTableHeader="retrievesTheTableHeader" :delEquipmentType="false" :gasSearch="true"></search-model>
    <equipment-head-manage ref="equipmentHeadManage" @retrievesTheTableHeader="retrievesTheTableHeader" searchCode="1800000000"></equipment-head-manage>
    <children-table-modules ref="childrenTableModules" @handleImport="handleImport" @derive="derive"></children-table-modules>
  </div>
</template>
<script>
import SearchForm from '@/views/equipmentLedger/modules/searchForm'
import {
  getDeptTreeList,
  getEquipmentBasicInfo,
  getEquipmentTableData,
  getEquipmentTableTotal,
  getEquipmentTree
} from '@/api/gasEquipmentLedger'
import DataTabs from '@/views/gasEquipmentLedger/modules/dataTabsModel/dataTabs.vue'
import { getTableScroll } from '@/views/gasEquipmentLedger/modules/height'
import { mapGetters } from 'vuex'
import DrawerDetail from '@/views/gasEquipmentLedger/modules/drawerDetail'
import drawerDetail2 from '@/views/centralizedManagement/modules/drawerDetailModules/drawerDetail.vue'
import drawerExport from '@/views/equipmentLedger/modules/drawerExportModel/drawerExport.vue'
import { getTypeFieldByTypeCode } from '@/api/deviceType'
import moment from 'moment'
import tableDrag from '../../../mixins/tableDrag'
import importModal from '@/views/equipmentLedger/modules/importModal/drawerImport.vue'
import searchModel from '@/views/equipmentLedger/modules/searchModel/searchModel.vue'
import equipmentHeadManage from '@/views/equipmentLedger/modules/equipmentHeadManage/equipmentHeadManage.vue'
import { delEquipment } from '@/api/equipmentLedger'
import ChildrenTableModules from '@/views/centralizedManagement/modules/childrenTableModules/childrenTableModules.vue'

const fourFont1440 = 95
const fourFontGreaterThan1440 = 135
const zyfz1440 = 110
const zyfzGreaterThan1440 = 115
const sbbh1440 = 140
const sbbhGreaterThan1440 = 140
const scrollX1440 = 1080
const scrollXGreaterThan1440 = 1250

export default {
  name: 'TableData',
  mixins: [tableDrag], // 此处不要忘记
  components: {
    ChildrenTableModules,
    DrawerDetail,
    drawerDetail2,
    drawerExport,
    DataTabs,
    SearchForm,
    importModal,
    searchModel,
    equipmentHeadManage
  },
  computed: {
    ...mapGetters(['centralizedManagementCompanyId', 'searchId']),
    columns: {
      get () {
        let { sortedInfo } = this
        sortedInfo = sortedInfo || {}
        this.columnsData.forEach(item => {
          if (item.sortOrNot) {
            item.sorter = (a, b) => {}
            item.sortOrder = sortedInfo.columnKey === item.dataIndex && sortedInfo.order
          }
          if (!item.isDate) {
            item.onFilterDropdownVisibleChange = visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          }
          if (item.title !== '序号') {
            const key = 'head_' + item.dataIndex
            this.headerSearchModel[key] = undefined
          }
        })
        return this.columnsData
      },
      set (newValue) {
        this.columnsData = newValue
      }
    },
    columnsInDrawer: {
      get () {
        let { sortedInfo } = this
        sortedInfo = sortedInfo || {}
        this.columnsDataInTable.forEach(item => {
          if (item.sortOrNot) {
            item.sorter = (a, b) => {}
            item.sortOrder = sortedInfo.columnKey === item.dataIndex && sortedInfo.order
          }
          if (!item.isDate) {
            item.onFilterDropdownVisibleChange = visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          }
        })
        return this.columnsDataInTable
      },
      set (newValue) {
        this.columnsDataInTable = newValue
      }
    }
  },
  data () {
    this.components = {
      header: {
        cell: this.resizeableTitle
      }
    }
    return {
      searchValue: '',
      // 表格数据
      tableData: {
        data: [],
        statistics: {
          sumTotal: 0,
          virtualTotal: 0,
          routineTotal: 0
        },
        loading: false
      },
      searchInput: null,
      columnsData: [],
      columnsDataInTable: [],
      originalTableHead: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return record.showIndex ? index + 1 : ''
          },
          align: 'center',
          fixed: 'left',
          width: 40
        },
        {
          title: '设备名称',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          customRender: (text, record, index) => {
            if (record.sign === 1 && record.required) {
              // 虚拟设备和未填写完成
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else if (record.sign === 1) {
              // 虚拟设备
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else if (record.required) {
              // 未填写完成
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else {
              return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
            }
          },
          dataIndex: 'name',
          sorter: (a, b) => {},
          align: 'left',
          fixed: 'left',
          width: window.screen.width <= 1440 ? 180 : 285,
          ellipsis: true
        },
        {
          title: '所属公司',
          dataIndex: 'suburl',
          scopedSlots: {
            customRender: 'suburl',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          title: '设备编号',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          dataIndex: 'equipmentNumber',
          sorter: (a, b) => {},
          align: 'center',
          ellipsis: true,
          width: window.screen.width <= 1440 ? sbbh1440 : sbbhGreaterThan1440
        },
        {
          title: '重要性分类',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          dataIndex: 'importanceType',
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? zyfz1440 : zyfzGreaterThan1440,
          ellipsis: true
        },
        {
          title: '规格型号',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          dataIndex: 'specification',
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        // {
        //   title: '技术参数',
        //   dataIndex: 'equipmentTypeName2',
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   width: 115,
        //   ellipsis: true
        // },
        {
          title: '设备分类',
          dataIndex: 'equipmentTypeName',
          scopedSlots: {
            customRender: 'equipmentTypeName',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        // {
        //   title: '供应商',
        //   dataIndex: 'manufacturer',
        //   scopedSlots: {
        //     customRender: 'manufacturer',
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon'
        //   },
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   width: 115,
        //   ellipsis: true
        // },
        // {
        //   title: '气体设备分级',
        //   dataIndex: 'equipmentTypeName3',
        //   scopedSlots: {
        //     customRender: 'equipmentTypeName3'
        //   },
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   width: 115,
        //   ellipsis: true
        // },
        {
          title: '设备状态',
          dataIndex: 'equipmentStatusName',
          scopedSlots: {
            customRender: 'equipmentStatusName',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          title: '特性',
          dataIndex: 'peculiarity',
          scopedSlots: {
            // filterDropdown: 'filterDropdown',
            // filterIcon: 'filterIcon',
            customRender: 'peculiarity'
          },
          // sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? 110 : fourFontGreaterThan1440,
          ellipsis: true
        },
        // {
        //   title: '处置状态',
        //   dataIndex: 'disposeType',
        //   align: 'center',
        //   width: 90,
        //   ellipsis: true
        // },
        {
          title: '归口部门',
          dataIndex: 'relevantdeptname',
          scopedSlots: {
            customRender: 'relevantdeptname',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          sorter: (a, b) => {},
          align: 'center',
          // width: 115,
          ellipsis: true
        }
        // {
        //   title: '使用年限',
        //   dataIndex: 'ndjar',
        //   align: 'center',
        //   width: 60,
        //   ellipsis: true
        // },
        // {
        //   title: '资产信息',
        //   dataIndex: 'assetInfoStatus',
        //   scopedSlots: {
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon'
        //   },
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   // width: 80,
        //   ellipsis: true
        // }
        // {
        //   title: '特',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions2'
        //   }
        // },
        // {
        //   title: '密',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions3'
        //   }
        // },
        // {
        //   title: '运',
        //   fixed: 'right',
        //   width: 45,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions6'
        //   }
        // },
        // {
        //   title: '保',
        //   fixed: 'right',
        //   width: 45,
        //   align: 'center',
        //   // customCell: (record, rowIndex) => {
        //   //   return {
        //   //     style: { background: '#0451A8' }
        //   //   }
        //   // },
        //   scopedSlots: {
        //     customRender: 'actions7'
        //   }
        // }
      ],
      originalTableHeadInDrawer: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return record.showIndex ? index + 1 : ''
          },
          align: 'center',
          fixed: 'left',
          width: 40
        },
        {
          title: '设备名称',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          customRender: (text, record, index) => {
            if (record.sign === 1 && record.required) {
              // 虚拟设备和未填写完成
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else if (record.sign === 1) {
              // 虚拟设备
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else if (record.required) {
              // 未填写完成
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else {
              return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
            }
          },
          dataIndex: 'name',
          sorter: (a, b) => {},
          align: 'left',
          fixed: 'left',
          width: window.screen.width <= 1440 ? 180 : 285,
          ellipsis: true
        },
        {
          title: '所属公司',
          dataIndex: 'suburl',
          scopedSlots: {
            customRender: 'suburl',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          title: '设备编号',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          dataIndex: 'equipmentNumber',
          sorter: (a, b) => {},
          align: 'center',
          ellipsis: true,
          width: window.screen.width <= 1440 ? sbbh1440 : sbbhGreaterThan1440
        },
        {
          title: '重要性分类',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          dataIndex: 'importanceType',
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? zyfz1440 : zyfzGreaterThan1440,
          ellipsis: true
        },
        {
          title: '规格型号',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          dataIndex: 'specification',
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        // {
        //   title: '技术参数',
        //   dataIndex: 'equipmentTypeName2',
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   width: 115,
        //   ellipsis: true
        // },
        {
          title: '设备分类',
          dataIndex: 'equipmentTypeName',
          scopedSlots: {
            customRender: 'equipmentTypeName',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        // {
        //   title: '供应商',
        //   dataIndex: 'manufacturer',
        //   scopedSlots: {
        //     customRender: 'manufacturer',
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon'
        //   },
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   width: 115,
        //   ellipsis: true
        // },
        // {
        //   title: '气体设备分级',
        //   dataIndex: 'equipmentTypeName3',
        //   scopedSlots: {
        //     customRender: 'equipmentTypeName3'
        //   },
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   width: 115,
        //   ellipsis: true
        // },
        {
          title: '设备状态',
          dataIndex: 'equipmentStatusName',
          scopedSlots: {
            customRender: 'equipmentStatusName',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          title: '特性',
          dataIndex: 'peculiarity',
          scopedSlots: {
            // filterDropdown: 'filterDropdown',
            // filterIcon: 'filterIcon',
            customRender: 'peculiarity'
          },
          // sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? 110 : fourFontGreaterThan1440,
          ellipsis: true
        },
        // {
        //   title: '处置状态',
        //   dataIndex: 'disposeType',
        //   align: 'center',
        //   width: 90,
        //   ellipsis: true
        // },
        {
          title: '归口部门',
          dataIndex: 'relevantdeptname',
          scopedSlots: {
            customRender: 'relevantdeptname',
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          sorter: (a, b) => {},
          align: 'center',
          // width: 115,
          ellipsis: true
        }
        // {
        //   title: '使用年限',
        //   dataIndex: 'ndjar',
        //   align: 'center',
        //   width: 60,
        //   ellipsis: true
        // },
        // {
        //   title: '资产信息',
        //   dataIndex: 'assetInfoStatus',
        //   scopedSlots: {
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon'
        //   },
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   // width: 80,
        //   ellipsis: true
        // }
        // {
        //   title: '特',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions2'
        //   }
        // },
        // {
        //   title: '密',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions3'
        //   }
        // },
        // {
        //   title: '运',
        //   fixed: 'right',
        //   width: 45,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions6'
        //   }
        // },
        // {
        //   title: '保',
        //   fixed: 'right',
        //   width: 45,
        //   align: 'center',
        //   // customCell: (record, rowIndex) => {
        //   //   return {
        //   //     style: { background: '#0451A8' }
        //   //   }
        //   // },
        //   scopedSlots: {
        //     customRender: 'actions7'
        //   }
        // }
      ],
      tableCurrRowId: null,
      dataTabsModel: {},
      sortedInfo: null,
      scrollY: 0,
      scrollX: 1250,
      toLeftWidth: 0,
      advanced: false,
      // 搜索条件
      searchModel: {
        equipmentType: '1800000000'
      },
      headerSearchModel: {},
      // 导出用到的搜索条件
      exportSearchModel: {},
      searchNum: 0,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      sort: {},
      // 展开的行
      expandedRowKeys: [],
      // 选中的行
      selectedRows: [],
      selectedRowKeys: [],
      // 左侧树的搜索条件
      treeSearchModel: {},
      // 当前选中展开的数据
      currentlySelectedExpansionData: {},
      disabled: false,
      visible: false,
      top: 0,
      left: 0,
      visibleShow: '',
      selectedRowsData: {}
    }
  },
  created () {
    // 获取表格数据
    // this.getDeptData()
    // 获取资产统计
    // this.scrollX = 1250
    this.columns = this.originalTableHead
    this.columnsInDrawer = this.originalTableHeadInDrawer
    this.getAssetTotal()
  },
  directives: {
    drag: {
      bind: function (el) {
        const filtrateDiv = el
        filtrateDiv.onmousedown = (e) => {
          // 获取body的高度
          const filtrateHeight = document.body.clientHeight - 70
          const x = e.clientX - filtrateDiv.offsetLeft
          const y = e.clientY - filtrateDiv.offsetTop
          window.onmousemove = (e) => {
            const cx = e.clientX - x
            let cy = e.clientY - y
            if (cy < 0) {
              cy = 0
            }
            if (cy > filtrateHeight - 35) {
              cy = filtrateHeight - 35
            }
            filtrateDiv.style.left = cx + 'px'
            filtrateDiv.style.top = cy + 'px'
            filtrateDiv.style.cursor = 'grabbing'
          }
          window.onmouseup = (e) => {
            // 移除filtrateDiv.style.left
            filtrateDiv.style.left = null
            filtrateDiv.style.right = '0px'
            filtrateDiv.style.cursor = 'grab'
            window.onmousemove = null
            window.onmouseup = null
          }
        }
      }
    }
  },
  mounted () {
    window.screen.width <= 1440 ? this.scrollX = scrollX1440 : this.scrollX = scrollXGreaterThan1440
  },
  watch: {
    centralizedManagementCompanyId (newValue) {
      for (const item in this.headerSearchModel) {
        this.headerSearchModel[item] = undefined
      }
      // 公司变化时，清空搜索条件中的部分字段，然后重新计算搜索条件数量
      if (this.searchNum > 0) {
        this.searchNum = this.$refs.searchForm.resetFields(this.searchNum)
      } else {
        this.$refs.searchForm.resetFields()
      }
      this.searchModel = this.$refs.searchForm.search('returnModel')
      if (newValue.id !== '') {
        if (newValue.id === '空') {
          delete this.treeSearchModel.subcompanyid
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
          this.tableData.statistics = {
            sumTotal: 0,
            virtualTotal: 0,
            routineTotal: 0
          }
        } else {
          this.treeSearchModel.subcompanyid = newValue.id
        }
      } else {
        delete this.treeSearchModel.subcompanyid
      }
      if (this.searchModel.subcompanyid) {
        delete this.searchModel.subcompanyid
      }
      if (this.searchModel.usedeptid) {
        delete this.searchModel.usedeptid
      }
      if (this.treeSearchModel.subcompanyid && this.treeSearchModel.id) {
        if (this.treeSearchModel.id === '000000') {
          if (newValue.id !== '空') {
            this.setSearchCondition(this.searchModel)
          }
        }
      }
    },
    searchId (newValue) {
      this.searchModel = this.$refs.searchForm.search('returnModel')
      for (const item in this.headerSearchModel) {
        this.headerSearchModel[item] = undefined
      }
      if (newValue.id === '空') {
        this.tableData.data = []
        this.pagination.total = 0
        this.tableData.loading = false
        const dom = document.getElementsByClassName('ant-table-body')[0]
        dom.classList.add('ant-table-body-max-height-0')
        if (this.advanced) {
          this.changeScrollY(90, 'addAssetTableHeigth')
        } else {
          this.changeScrollY(94)
        }
        this.tableData.statistics = {
          sumTotal: 0,
          virtualTotal: 0,
          routineTotal: 0
        }
      } else {
        this.treeSearchModel.id = newValue.id
      }
      if (this.treeSearchModel.subcompanyid && this.treeSearchModel.id) {
        if (newValue.id !== '空') {
          this.setSearchCondition(this.searchModel)
        }
      }
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    // 展开图标
    expandIcon (props) {
      if (props.record.children && (props.record.children.length > 0 || props.record.children.length === 0)) {
        if (props.expanded) {
          return (
            <span
              class="table-icon table-icon-down"
              onClick={(e) => {
                this.tableData.loading = true
                setTimeout(() => {
                  props.record.children = []
                }, 500)
                setTimeout(() => {
                  props.onExpand(props.record, e)
                  this.tableData.loading = false
                }, 500)
              }}
            >
              <a-icon type="caret-down" />
            </span>
          )
        } else {
          return (
            <span
              class="table-icon table-icon-right"
              onClick={(e) => {
                if (props.record.displayType === '1') {
                  // 下拉
                  props.onExpand(props.record, e)
                  this.tableCurrRowId = props.record.id
                  this.getChildren(props.record, true)
                } else {
                  this.tableCurrRowId = props.record.id
                  this.getChildren(props.record, false)
                }
              }}
            >
              <a-icon type="caret-right" />
            </span>
          )
        }
      } else {
        return <span style="margin-right:19px"></span>
      }
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      // 赋值同步本地data接受数据(我这里只取id即可)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.getAssetTotal()
    },
    // 改变scrollY
    changeScrollY (extraHeight, type) {
      this.$nextTick(() => {
        this.scrollY = getTableScroll(extraHeight, 'assetTable', type)
        const dom = document.getElementById('assetTable')
        if (type === 'addAssetTableHeigth') {
          dom.classList.add('assetTableHeight_126')
        } else {
          dom.classList.remove('assetTableHeight_126')
        }
      })
    },
    // 保存展开状态字段
    saveAdvanced (advanced) {
      this.advanced = advanced
    },
    // 打开抽屉
    openDrawer (type) {
      if (type !== 'add') {
        this.$refs.drawerDetail2.setModel(this.selectedRowsData, type)
      }
      this.$refs.drawerDetail2.setTitle(type === 'add' ? '新增设备' : type === 'edit' ? '编辑设备' : '复制设备')
      this.$refs.drawerDetail2.setType(type)
      if (type !== 'edit') {
        this.$refs.drawerDetail2.setPname('一级设备')
      }
      this.$refs.drawerDetail2.open(true)
    },
    showDelTip () {
      const that = this
      that.$confirm({
        title: (h) => {
          return h('div', {
            domProps: {
              innerHTML: '确定删除该数据吗'
            }
          })
        },
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          that.del()
        },
        onCancel () {

        }
      })
    },
    // 删除
    del () {
      function findById (treeData, id) {
        for (const item of treeData) {
          if (item.id === id) {
            return item
          } else if (item.children) {
            const result = findById(item.children, id)
            if (result) {
              return result
            }
          }
        }
        return null
      }
      if (this.selectedRowsData.pnode) {
        this.$message.error('当前数据包含子节点，不允许删除')
        return
      }
      const data = {
        ids: this.selectedRowsData.id
      }
      this.btnLoading = true
      delEquipment(data).then(res => {
        if (res.status === 0) {
          if (this.exportSearchModel.hasOwnProperty('pid')) {
            if (this.selectedRowsData.pid !== '0') {
              // 找到要删除节点的父节点
              const pData = findById(this.tableData.data, this.selectedRowsData.pid)
              // 获取到要删除节点在父节点中的下标
              const findIndex = pData.children.findIndex(item => item.id === this.selectedRowsData.id)
              // 删除节点
              pData.children.splice(findIndex, 1)
              if (pData.children.length === 0) {
                pData.pnode = false
                delete pData.children
              }
            } else {
              this.getTableData(true)
            }
          } else {
            this.getTableData(true)
          }
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 导入
    handleImport () {
      this.$refs.importModal.open(true)
    },
    // 导出
    derive () {
      this.$refs.drawerExport.setTitle('导出')
      this.$refs.drawerExport.setModel(this.exportSearchModel)
      this.$refs.drawerExport.setType(this.$sysInfo.MODAL_ADD)
      // this.$refs.drawerExport.setEquipmentType(this.searchModel.equipmentType)
      this.$refs.drawerExport.open(true)
    },
    //  获取部门树用于第一次请求表格
    getDeptData () {
      const data = {
        paging: false,
        id: 0
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          this.treeSearchModel.subcompanyid = res.data[0].id
          this.setSearchCondition(this.searchModel)
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 修改表格数据
    formateData (data) {
      const childrenArr = []
      data.forEach(item => {
        item.showIndex = false
        if (item.children) {
          item.marginRight = true
          this.formateData(item.children)
        } else {
          item.marginLeft = true
        }
        childrenArr.push(item)
      })
      return childrenArr
    },
    // 获取表格数据
    getTableData (resetModel) {
      this.tableData.loading = true
      this.expandedRowKeys = []
      this.selectedRows = []
      this.selectedRowKeys = []
      const paramsCheck = JSON.parse(JSON.stringify({ ...this.searchModel, ...this.pagination, ...this.sort }))
      let delPid = false
      for (const key in paramsCheck) {
        if (key.indexOf('head_') > -1) {
          delPid = true
          const checkKey = key.split('_')[1]
          paramsCheck[checkKey] = paramsCheck[key]
          delete paramsCheck[key]
        }
      }
      if (this.searchModel.seatchType || this.searchModel.delpid || delPid) {
        // searchType用于上面的搜索条件判断是否有搜索条件
        // delpid用于详情搜索条件判断是否有搜索条件
        const params = { ...paramsCheck }
        this.exportSearchModel = params
        getEquipmentTableData(params).then(res => {
          if (res.status === 0) {
            res.data.list.forEach((item) => {
              item.showIndex = true
              delete item.children
              if (item.children) {
                // 修改表格数据
                item.marginRight = true
                item.children = this.formateData(item.children)
              }
            })
            if (res.data.list.length > 0) {
              this.tableData.data = res.data.list
              this.pagination.total = res.data.total
              if (resetModel) {
                this.dataTabsModel = this.tableData.data[0]
              }
            } else {
              this.tableData.data = []
              this.pagination.total = 0
              this.dataTabsModel = {}
              this.tableCurrRowId = ''
            }
            this.$nextTick(() => {
              // 获取ant-table-body的dom，并且给它添加鼠标右键事件
              const tableBodyDom = document.getElementsByClassName('ant-table-body')[0]
              const tableBodyDom2 = document.getElementsByClassName('ant-empty-normal')[0]
              const tableBodyDom3 = document.getElementsByClassName('ant-table-fixed-left')[0]
              const tableBodyDom4 = document.getElementsByClassName('ant-table-placeholder')[0]
              tableBodyDom.oncontextmenu = this.openContextmenu
              if (tableBodyDom2) {
                tableBodyDom2.oncontextmenu = this.openContextmenu
              }
              if (tableBodyDom3) {
                tableBodyDom3.oncontextmenu = this.openContextmenu
              }
              if (tableBodyDom4) {
                tableBodyDom4.oncontextmenu = this.openContextmenu
              }
            })
            this.tableData.loading = false
            if (this.advanced) {
              this.changeScrollY(90, 'addAssetTableHeigth')
            } else {
              this.changeScrollY(94)
            }
          } else {
            this.tableData.data = []
            this.tableData.total = 0
            this.tableData.loading = false
            this.$message.error(res.info.message)
          }
        })
      } else {
        const params = { ...paramsCheck }
        params.pid = 0
        this.exportSearchModel = params
        getEquipmentTree(params).then(res => {
          if (res.status === 0) {
            res.data.list.forEach((item) => {
              item.showIndex = true
              if (item.pnode) {
                item.children = []
              } else {
                delete item.children
              }
              if (item.children) {
                // 修改表格数据
                item.marginRight = true
                item.children = this.formateData(item.children)
              }
            })
            if (res.data.list.length > 0) {
              this.tableData.data = res.data.list
              this.pagination.total = res.data.total
              if (resetModel) {
                this.dataTabsModel = this.tableData.data[0]
              }
            } else {
              this.tableData.data = []
              this.pagination.total = 0
              this.dataTabsModel = {}
              this.tableCurrRowId = ''
            }
            this.$nextTick(() => {
              // 获取ant-table-body的dom，并且给它添加鼠标右键事件
              const tableBodyDom = document.getElementsByClassName('ant-table-body')[0]
              const tableBodyDom2 = document.getElementsByClassName('ant-empty-normal')[0]
              const tableBodyDom3 = document.getElementsByClassName('ant-table-fixed-left')[0]
              const tableBodyDom4 = document.getElementsByClassName('ant-table-placeholder')[0]
              tableBodyDom.oncontextmenu = this.openContextmenu
              if (tableBodyDom2) {
                tableBodyDom2.oncontextmenu = this.openContextmenu
              }
              if (tableBodyDom3) {
                tableBodyDom3.oncontextmenu = this.openContextmenu
              }
              if (tableBodyDom4) {
                tableBodyDom4.oncontextmenu = this.openContextmenu
              }
            })
            this.tableData.loading = false
            if (this.advanced) {
              this.changeScrollY(90, 'addAssetTableHeigth')
            } else {
              this.changeScrollY(94)
            }
          } else {
            this.tableData.data = []
            this.tableData.total = 0
            this.tableData.loading = false
            this.$message.error(res.info.message)
          }
        })
      }
      // 获取统计
      this.getAssetTotal()
    },
    // 获取假的子数据
    getChildren (data, pushChildren) {
      if (pushChildren) {
        // 写一个findChildIndex的方法，在this.tableData.data这个多层树形结构中找到当前id等于data.id的这个数据的索引
        this.currentlySelectedExpansionData = data
        const params = {
          pid: data.id,
          paging: false
        }
        this.tableData.loading = true
        getEquipmentTree(params).then(res => {
          if (res.data.length > 0) {
            for (const resData of res.data) {
              if (resData.pnode) {
                resData.children = []
              } else {
                delete resData.children
              }
            }
            // data.children = res.data
            const findChildrenIndex = (table) => {
              for (const item of table) {
                if (item.id === data.id) {
                  item.children = res.data
                  break
                } else {
                  if (item.children) {
                    findChildrenIndex(item.children)
                  }
                }
              }
            }
            findChildrenIndex(this.tableData.data)
          }
          this.tableData.loading = false
        })
      } else {
        this.$refs.childrenTableModules.setTitle(`${data.name}的子设备列表`)
        this.$refs.childrenTableModules.setTableColumns(this.columnsInDrawer)
        this.$refs.childrenTableModules.setpModel(data)
        this.$refs.childrenTableModules.setScrollX(this.scrollX)
        this.$refs.childrenTableModules.open(true)
      }
    },
    // 获取统计
    getAssetTotal () {
      const params = JSON.parse(JSON.stringify(this.exportSearchModel))
      if (this.selectedRowKeys.length > 0) {
        params.idList = JSON.parse(JSON.stringify(this.selectedRowKeys))
      }
      if (params.id) {
        if (!params.idList) {
          params.idList = []
        }
        if (params.idList.indexOf(params.id) > -1) {
          params.idList.splice(params.idList.indexOf(params.id), 1)
        }
        if (this.selectedRows.findIndex(item => item.pid === params.id) === -1) {
          params.idList.push(params.id)
        }
        delete params.id
      }
      getEquipmentTableTotal(params).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.tableData.statistics = res.data
          } else {
            this.tableData.statistics = {
              sumTotal: 0,
              virtualTotal: 0,
              routineTotal: 0
            }
          }
        }
      })
    },
    // 表头搜索
    async handleSearch (selectedKeys, confirm, column) {
      const key = 'head_' + column.dataIndex
      this.headerSearchModel[key] = typeof selectedKeys[0] === 'object' ? selectedKeys[0].format('YYYY-MM-DD') : selectedKeys[0]
      const searchModel = this.$refs.searchForm.search('returnModel')
      await this.collateSearchData(searchModel)
      await this.setSearchCondition(this.searchModel)
      // confirm()
    },
    // 表头重置
    handleReset (clearFilters, column) {
      const key = 'head_' + column.dataIndex
      this.headerSearchModel[key] = undefined
      delete this.searchModel[key]
      this.setSearchCondition(this.searchModel)
    },
    // 清除表头搜索字段
    cleanheadInSearchModel () {
      for (const key in this.headerSearchModel) {
        this.headerSearchModel[key] = undefined
      }
    },
    // 定位表格滚动条至指定位置
    fixedTableScroll (scrollLeft, scrollTop) {
      this.$nextTick(() => {
        const tableBody = document.getElementById('assetTable').getElementsByClassName('ant-table-body')[0]
        tableBody.scrollLeft = scrollLeft
        tableBody.scrollTop = scrollTop
      })
    },
    // 整理搜索数据
    collateSearchData (searchModel) {
      return new Promise((resolve, reject) => {
        this.searchModel = searchModel
        for (const key in this.searchModel) {
          if (key.indexOf('head_') > -1) {
            delete this.searchModel[key]
          }
        }
        const obj = {}
        if (this.searchModel) {
          try {
            for (const key in this.headerSearchModel) {
              if (this.headerSearchModel[key] !== undefined) {
                // 取heat_后面的字段
                const checkKey = key.split('_')[1]
                if (checkKey === 'equipmentStatusName') {
                  // 设备状态
                  if (this.searchModel.equipmentStatus) {
                    // 抛出异常
                    throw new Error('表头搜素条件和顶部搜索条件冲突')
                  }
                }
                // 归口部门
                if (checkKey === 'relevantdeptname') {
                  if (this.searchModel.relevantdeptid) {
                    // 抛出异常
                    throw new Error('表头搜素条件和顶部搜索条件冲突')
                  }
                }
                // 归口部门负责人
                if (checkKey === 'relevantdeptUserName') {
                  if (this.searchModel.relevantdeptUserId) {
                    // 抛出异常
                    throw new Error('表头搜素条件和顶部搜索条件冲突')
                  }
                }
                // 使用部门
                if (checkKey === 'usedeptname') {
                  if (this.searchModel.usedeptid) {
                    // 抛出异常
                    throw new Error('表头搜素条件和顶部搜索条件冲突')
                  }
                }
                // 判断this.searchModel对象中是否有key属性
                if (checkKey in this.searchModel) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
                obj[key] = this.headerSearchModel[key]
              }
            }
          } catch (error) {
            this.$message.error('表头搜素条件和顶部搜索条件冲突')
            return
          }
        }
        this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...obj, ...searchModel }
        resolve()
      })
      // return this.searchModel
    },
    // 搜索
    setSearchCondition (searchModel, changeSearch, searchNum, notSearch) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      if (changeSearch) {
        this.$refs.searchForm.changeSearchModel(searchModel)
        this.searchNum = searchNum
      }
      for (const key in this.searchModel) {
        if (key.indexOf('head_') > -1) {
          delete this.searchModel[key]
        }
      }
      const obj = {}
      if (this.searchModel) {
        try {
          for (const key in this.headerSearchModel) {
            if (this.headerSearchModel[key] !== undefined) {
              // 取heat_后面的字段
              const checkKey = key.split('_')[1]
              if (checkKey === 'equipmentStatusName') {
                // 设备状态
                if (this.searchModel.equipmentStatus) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 归口部门
              if (checkKey === 'relevantdeptname') {
                if (this.searchModel.relevantdeptid) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 归口部门负责人
              if (checkKey === 'relevantdeptUserName') {
                if (this.searchModel.relevantdeptUserId) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 使用部门
              if (checkKey === 'usedeptname') {
                if (this.searchModel.usedeptid) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 判断this.searchModel对象中是否有key属性
              if (checkKey in this.searchModel) {
                // 抛出异常
                throw new Error('表头搜素条件和顶部搜索条件冲突')
              }
              obj[key] = this.headerSearchModel[key]
            }
          }
        } catch (error) {
          this.$message.error('表头搜素条件和顶部搜索条件冲突')
          return
        }
      }
      delete this.searchModel.id
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...obj, ...searchModel }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      if (this.treeSearchModel.id === '000000') {
        delete this.searchModel.id
      }
      // this.retrievesTheTableHeader([this.searchModel.equipmentType])
      if (!notSearch) {
        this.getTableData(true)
      }
    },
    // 重置
    clearSearch (searchModel) {
      this.sort = {}
      this.sortedInfo = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchNum = 0
      const obj = {}
      if (this.searchModel) {
        try {
          for (const key in this.headerSearchModel) {
            if (this.headerSearchModel[key] !== undefined) {
              // 取heat_后面的字段
              const checkKey = key.split('_')[1]
              if (checkKey === 'equipmentStatusName') {
                // 设备状态
                if (this.searchModel.equipmentStatus) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 归口部门
              if (checkKey === 'relevantdeptname') {
                if (this.searchModel.relevantdeptid) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 归口部门负责人
              if (checkKey === 'relevantdeptUserName') {
                if (this.searchModel.relevantdeptUserId) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 使用部门
              if (checkKey === 'usedeptname') {
                if (this.searchModel.usedeptid) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 判断this.searchModel对象中是否有key属性
              if (checkKey in this.searchModel) {
                // 抛出异常
                throw new Error('表头搜素条件和顶部搜索条件冲突')
              }
              obj[key] = this.headerSearchModel[key]
            }
          }
        } catch (error) {
          this.$message.error('表头搜素条件和顶部搜索条件冲突')
          return
        }
      }
      delete this.searchModel.id
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...obj }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      if (this.treeSearchModel.id === '000000') {
        delete this.searchModel.id
      }
      this.getTableData(true)
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.sort.sortName = sorter.field
      if (sorter.order) {
        if (sorter.order === 'ascend') {
          this.sort.sortType = 'asc'
        } else if (sorter.order === 'descend') {
          this.sort.sortType = 'desc'
        }
      } else {
        delete this.sort.sortName
        delete this.sort.sortType
        delete this.searchModel.sortName
        delete this.searchModel.sortType
      }
      delete this.searchModel.id
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      if (this.treeSearchModel.id === '000000') {
        delete this.searchModel.id
      }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      this.getTableData(true)
    },
    // 关闭右键菜单
    closeMenu () {
      this.visible = false
    },
    // 行
    changeRow (record) {
      return {
        on: {
          contextmenu: (e) => {
            e.preventDefault()
            e.stopPropagation()
            this.$emit('closeMenu', 'rightTable')
            this.selectedRowsData = record
            this.tableCurrRowId = record.id
            var x = e.pageX - 253//  - 239
            var y = e.pageY - 54//
            this.top = y
            this.left = x
            this.visibleShow = 'all'
            this.visible = true
          },
          dblclick: (event) => { // 双击行,双击选中
            if (!record.dblclickDisabled) {
              this.disabled = false
              this.$refs.drawerDetail.setTitle('设备详情')
              this.$refs.drawerDetail.setType('edit')
              this.$refs.drawerDetail.setModel(record)
              this.$refs.drawerDetail.open(true)
            }
          },
          click: (event) => { // 单击行,双击选中
            this.tableCurrRowId = record.id
            this.dataTabsModel = {}
            this.dataTabsModel = record
          }
        }
      }
    },
    openContextmenu (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('closeMenu', 'rightTable')
      this.top = e.pageY - 54
      this.left = e.pageX - 253
      this.visibleShow = 'part'
      this.visible = true
    },
    // 右键插入设备
    plugInDevice (type) {
      if (type === 'father') {
        //  插入父设备
        if (this.selectedRowsData.pid !== '0' && this.selectedRowsData.pid !== null) {
          this.$message.warning('该设备已存在父设备，无法添加父设备')
        } else {
          this.tableCurrRowId = this.selectedRowsData.id
          this.dataTabsModel = {}
          this.dataTabsModel = this.selectedRowsData
          this.$refs.drawerDetail2.setTitle('新增父设备')
          this.$refs.drawerDetail2.setType('add')
          this.$refs.drawerDetail2.setSonId(this.selectedRowsData.id)
          this.$refs.drawerDetail2.setPname('一级设备')
          this.$refs.drawerDetail2.setDataTabsModel(this.selectedRowsData)
          this.$refs.drawerDetail2.open(true)
        }
      } else {
        this.tableCurrRowId = this.selectedRowsData.id
        this.dataTabsModel = {}
        this.dataTabsModel = this.selectedRowsData
        //  插入子设备
        this.$refs.drawerDetail2.setTitle('新增子设备')
        this.$refs.drawerDetail2.setType('add')
        this.$refs.drawerDetail2.setPid(this.selectedRowsData.id)
        this.$refs.drawerDetail2.setPname(this.selectedRowsData.name)
        this.$refs.drawerDetail2.setDataTabsModel(this.selectedRowsData)
        this.$refs.drawerDetail2.open(true)
      }
    },
    // 子设备新增成功之后插入子设备
    setChildrenData (data, length) {
      // data.children = []
      if (this.exportSearchModel.hasOwnProperty('pid')) {
        if (length > 1) {
          if (this.selectedRowsData.children) {
            data.forEach(item => {
              if (this.selectedRowsData.children) {
                this.selectedRowsData.children.push(item)
              }
            })
          } else {
            this.selectedRowsData.children = data
          }
        } else {
          if (this.selectedRowsData.children) {
            this.selectedRowsData.children.push(data[0])
          } else {
            this.selectedRowsData.children = data
          }
          if (this.expandedRowKeys.indexOf(this.selectedRowsData.id) === -1) {
            this.expandedRowKeys.push(this.selectedRowsData.id)
          }
          this.tableCurrRowId = data[0].id
          this.$forceUpdate()
        }
      } else {
        this.getTableData(true)
      }
    },
    // 编辑成功之后更新数据
    updateData (data) {
      this.tableData.loading = true
      let childeren = []
      if (this.selectedRowsData.children) {
        childeren = JSON.parse(JSON.stringify(this.selectedRowsData.children))
      }
      for (const dataKey in data) {
        this.selectedRowsData[dataKey] = data[dataKey]
      }
      if (childeren.length > 0) {
        this.selectedRowsData.children = childeren
      }
      this.tableData.loading = false
      this.getDataTabs(data.id)
      this.$forceUpdate()
    },
    getDataTabs (id) {
      this.dataTabsModel = {}
      const data = {
        id: id
      }
      getEquipmentBasicInfo(data).then(res => {
        if (res.status === 0) {
          this.dataTabsModel = res.data
        }
      })
    },
    rowClassName (record, index) {
      return (record.id === this.tableCurrRowId) ? 'yellow' : ''
    },
    showEquipmentHeadManage () {
      this.$refs.equipmentHeadManage.open()
    },
    // 重置表头
    resetTableHead (res, changeEquipment, elseFun, searchModel, searchNum, notSearch) {
      if (res.status === 0) {
        if (res.data.length > 0) {
          let width = 0
          const table = JSON.parse(JSON.stringify(res.data))
          const tableInDrawer = JSON.parse(JSON.stringify(res.data))
          table.forEach((item, index) => {
            item.ellipsis = true
            item.width = 200
            item.align = 'center'
            if (item.dataIndex !== 'equipmentStatusName') {
              item.customRender = (text, record, index) => {
                return <a-tooltip placement="topLeft"><template slot="title">{record[item.dataIndex]}</template><span>{record[item.dataIndex]}</span></a-tooltip>
              }
            }
            if (index === 0) {
              item.fixed = 'left'
              item.align = 'left'
              item.customRender = (text, record, index) => {
                if (record.sign === 1 && record.required) {
                  // 虚拟设备和未填写完成
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else if (record.sign === 1) {
                  // 虚拟设备
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else if (record.required) {
                  // 未填写完成
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else {
                  return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                }
              }
            }
            if (index === res.data.length - 1) {
              item.width = null
            }
            if (item.isDate) {
              item.customRender = (text, record, index) => {
                return record[item.dataIndex] ? moment(record[item.dataIndex]).format('YYYY-MM-DD') : ''
              }
              // delete item.scopedSlots
            }
            if (item.type === 1) {
              item.scopedSlots = {
                ...item.scopedSlots,
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon'
              }
            }
            width += item.width
            const key = 'head_' + item.dataIndex
            this.headerSearchModel[key] = undefined
            if (!changeEquipment) {
              if (this.searchModel[key]) {
                this.headerSearchModel[key] = this.searchModel[key]
              }
            }
          })
          table.unshift(
            {
              title: '序号',
              customRender: (text, record, index) => {
                return record.showIndex ? index + 1 : ''
              },
              align: 'center',
              fixed: 'left',
              width: 40,
              setWidth: true
            }
          )

          tableInDrawer.forEach((item, index) => {
            item.ellipsis = true
            item.width = 200
            item.align = 'center'
            if (item.dataIndex !== 'equipmentStatusName') {
              item.customRender = (text, record, index) => {
                return <a-tooltip placement="topLeft"><template slot="title">{record[item.dataIndex]}</template><span>{record[item.dataIndex]}</span></a-tooltip>
              }
            }
            if (index === 0) {
              item.fixed = 'left'
              item.align = 'left'
              item.customRender = (text, record, index) => {
                if (record.sign === 1 && record.required) {
                  // 虚拟设备和未填写完成
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else if (record.sign === 1) {
                  // 虚拟设备
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else if (record.required) {
                  // 未填写完成
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else {
                  return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                }
              }
            }
            if (index === res.data.length - 1) {
              item.width = null
            }
            if (item.isDate) {
              item.customRender = (text, record, index) => {
                return record[item.dataIndex] ? moment(record[item.dataIndex]).format('YYYY-MM-DD') : ''
              }
            }
            if (item.type === 1) {
              item.scopedSlots = {
                ...item.scopedSlots,
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon'
              }
            }
          })
          tableInDrawer.unshift(
            {
              title: '序号',
              customRender: (text, record, index) => {
                return record.showIndex ? index + 1 : ''
              },
              align: 'center',
              fixed: 'left',
              width: 40,
              setWidth: true
            }
          )
          this.scrollX = width + 235
          this.columns = table
          this.columnsInDrawer = tableInDrawer
          if (!changeEquipment) {
            this.fixedTableScroll(0, 0)
          } else {
            this.setSearchCondition(searchModel || this.searchModel, true, searchNum, notSearch)
          }
        } else {
          elseFun()
        }
      } else {
        elseFun()
      }
    },
    // 判断是否需要重新获取表头
    retrievesTheTableHeader (list, changeEquipment, searchModel, searchNum, notSearch) {
      const that = this
      let index = 0
      if (!searchModel) {
        index = list.findIndex(item => item === this.searchModel.equipmentType)
      }
      if (index >= 0) {
        const params = {
          typeCode: searchModel ? searchModel.equipmentType : this.searchModel.equipmentType,
          type: 3
        }
        this.headerSearchModel = {}
        this.tableData.loading = true
        this.cleanheadInSearchModel()
        getTypeFieldByTypeCode(params).then(res => {
          function elseFun () {
            that.scrollX = window.screen.width <= 1440 ? scrollX1440 : scrollXGreaterThan1440
            that.columns = that.originalTableHead
            that.setSearchCondition(searchModel || that.searchModel, true, searchNum, notSearch)
            that.fixedTableScroll(0, 0)
          }
          this.resetTableHead(res, changeEquipment, elseFun, searchModel, searchNum, notSearch)
          this.tableData.loading = false
        }).catch(err => {
          this.scrollX = window.screen.width <= 1440 ? scrollX1440 : scrollXGreaterThan1440
          this.columns = this.originalTableHead
          that.setSearchCondition(searchModel || that.searchModel, true, searchNum, notSearch)
          this.fixedTableScroll(0, 0)
          // this.tableData.loading = false
        })
      }
    },
    // 打开详细查询弹窗
    showSearchModel () {
      this.$nextTick(() => {
        this.$refs.searchModel.open(true)
        this.$refs.searchModel.setSearchModel(JSON.parse(JSON.stringify(this.searchModel)))
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-table-tbody {
  cursor: pointer;
}
/deep/.ant-table-tbody .yellow{
  background-color: rgba(253, 250, 199, 1) !important;
}
.rightTableDiv {
  height: 100%;
  overflow-x: hidden;
  position: relative;
  .filtrate,.filtrateNum {
    width: 80px;
    position: absolute;
    right: 0;
    background: #1791FF;
    box-shadow: 0px 5px 10px 0px rgba(8,64,159,0.5);
    border-radius: 3px;
    z-index: 999;
    cursor: grab;
    span {
      color: #FFFFFF;
    }
  }
  .filtrate {
    height: 32px;
    top: 0px;
    line-height: 32px;
    text-align: center;
    span {
      font-size: 14px;
      color: #FFFFFF;
    }
  }
  .filtrateNum {
    height: 60px;
    top: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .circle {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      margin-top: 6px;
      background: #FFFFFF;
      box-shadow: 0px 5px 10px 0px rgba(8,64,159,0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      span {
        color: #1791FF;
        font-size: 12px;
      }
    }
  }
  /deep/.assetTable  {
    transition: height 300ms ease;
    height: calc(100% - 42px);
    >.ant-spin-nested-loading {
      height: 100%;
      >.ant-spin-container {
        height: calc(100% - 43px);
        .ant-table {
          height: 100%;
          table {
            border-collapse: collapse !important;
          }
          .ant-table-content {
            height: 100%;
            .ant-table-scroll{
              height: 100%;
              .ant-table-body {
                transition: max-height 300ms ease;
                height: calc(100% - 80px);
              }
              >.ant-table-placeholder {
                position: absolute;
                background: none;
                border-top: none;
                border-bottom: none;
                border-radius: 0 0 4px 4px;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                height: 100px;
                .ant-empty-normal {
                  margin: 0 !important;
                }
              }
            }
          }
        }
        >.ant-table-pagination.ant-pagination {
          margin: 10px 0 0 0 !important;
        }
      }
    }
    .ant-table-pagination.ant-pagination {
      margin: 10px;
    }
  }
}
.listContent {
  .table {
    margin-top: 10px;
  }
}
.ant-table-row-collapsed::after {
  content: '+';
  color: #DDDDDD;
}
.ant-table-row-expanded::after {
  content: '-';
  color: #DDDDDD;
}
/deep/.ant-table-footer {
  padding: 0 !important;
  height: 40px;
  .footerDiv {
    display: flex;
    flex-direction: row;
    //justify-content: space-between;
    background-color: #FFFFFF;
    //background-color: #E7F4FF;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    .footerDivOne ,.footerDivTwo ,.footerDivThree {
      //width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      //justify-content: flex-start;
      align-items: center;
      padding: 0 20px;
      color: #333333;
      background-color: #E7F4FF;
      font-weight: 500;
      span:first-child {
        //margin-right: 20px;
      }
    }
    .footerDivOne {
      width: calc(100% / 3 - 2px);
      //border-right: 1px solid #DDDDDD;
    }
    .footerDivTwo {
      width: calc(100% / 3 - 4px);
      //border-right: 1px solid #DDDDDD;
      margin: 0 auto;
    }
    .footerDivThree {
      width: calc(100% / 3 - 2px);
    }
  }
}
/deep/.ant-table-expanded-row{
  >td{
    padding: 0;
    .expand_row{
      display: flex;
      .expand_left{
        width: 80px;
        border-right: 1px solid #e8e8e8;
      }
      .expand_right{
        width: calc(100% - 80px);
        //padding: 0 10px 8px 10px;
      }
    }
  }
}
.assetTableHeight_126 {
  height: calc(100% - 126px) !important;
}
.assetNameTable {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
/deep/.ant-table-row {
  td {
    padding: 6px 10px !important;
    position: relative;
  }
  .ant-table-column-has-sorters:nth-child(3) {
    //display: flex;
    //height: 43px;
    //flex-direction: row;
    //justify-content: center;
    //align-items: center;
  }
}
.table-icon {
  margin-right: 7px;
  color: #87909f;
  font-size: 12px;
  cursor: pointer;
}
.table-icon-down {
  color: #08409f;
}
.table-icon-right {
  color: #dddddd;
}
.blueBtn {
  background: rgba(23, 145, 255, 0.1) !important;
  color: #1791FF;
  border: 1px solid rgba(23, 145, 255, 0.7) !important;
}
.orangeBtn {
  background: rgba(255, 142, 59, 0.1) !important;
  color: #FF8E3B;
  border: 1px solid rgba(255, 142, 59, 0.7) !important;
}
.greenBtn {
  background: rgba(54, 191, 125, 0.1) !important;
  color: #36BF7D;
  border: 1px solid rgba(54, 191, 125, 0.7) !important;
}
/deep/.ant-table-align-center {
  padding: 0 !important;
}
/deep/.ant-table-body-max-height-0 {
}
.rd {
  position: absolute;
  top: 0;
  left: 0;
  background-image: url("./1.png");
  width: 30px;
  height: 30px;
}
.padding-4-8 {
  padding: 4px 8px !important;
}
.xuIcon {
  margin-right: 5px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(23,145,255,0.7);
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 3px;
  color: #1791FF;
}
.daiIcon {
  margin-right: 5px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(231, 59, 59, 0.50);
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 3px;
  color: rgba(231, 59, 59, 1);
}
.redIcon {
  margin-right: 5px;
  background-color: #E73B3B1A;
  border: 1px solid rgba(231, 59, 59, 0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #E73B3B;
}
.orgIcon {
  margin-right: 5px;
  background: rgba(255,142,59,0.1);
  border: 1px solid rgba(255,142,59,0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #FF8E3B;
}
.blueIcon {
  margin-right: 5px;
  background: rgba(23,145,255,0.1);
  border: 1px solid rgba(23,145,255,0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #1791FF;
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: rgba(231, 244, 255, 1);
}
#assetTable {
  /deep/.ant-table-fixed-right {
    >.ant-table-body-outer {
      //height: calc(100% - 36px);
      >.ant-table-body-inner {
        max-height: calc(100vh - 228px) !important;
      }
    }
  }
  /deep/.ant-table-fixed-left {
    height: calc(100% - 50px);
    .ant-table-header {
      //border-left: 0.8px solid rgba(185, 222, 255, 1);
    }
    .ant-table-fixed {
      border-left: 0.8px solid rgba(185, 222, 255, 1);
      border-bottom: 0.8px solid rgba(185, 222, 255, 1) !important;
    }
    .ant-table-body-outer {
      height: calc(100% - 36px);
      .ant-table-body-inner {
        overflow: hidden scroll;
      }
    }
  }
}
/deep/.table-draggable-handle {
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
/deep/.resize-table-th {
  position: relative;
}
/deep/.ant-table-column-sorter-inner-full {
  margin-top: -0.5em !important;
}
</style>
